import { Close } from '@mui/icons-material';
import { Box, IconButton, Tab, Tabs, Typography } from '@mui/material';
import { useState } from 'react';
import { ToolInfoDto } from '../../UserSearch/api/models/ToolInfoDto';
import AdminToolManagerManagement from './AdminToolManagers/AdminToolManagerManagement';

interface AdminToolManagementProps {
    tool: ToolInfoDto;
    onClose: () => void;
}

const AdminToolManagement = ({ tool, onClose }: AdminToolManagementProps): JSX.Element => {
    const [selectedTab, setSelectedTab] = useState('access');

    const onTabChange = (_: React.SyntheticEvent, newValue: string) => {
        setSelectedTab(newValue);
    };

    return (
        <Box sx={{ width: '70vw', p: 3 }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    mb: 3,
                }}
            >
                <Typography variant='h5'> {tool.toolDisplayName || tool.toolName}</Typography>
                <IconButton aria-label='Close manage access' onClick={onClose}>
                    <Close />
                </IconButton>
            </Box>
            <Tabs
                value={selectedTab}
                onChange={onTabChange}
                aria-label='wrapped label tabs example'
            >
                <Tab value='access' label='Manage access' />
            </Tabs>
            {selectedTab === 'access' && <AdminToolManagerManagement tool={tool} />}
        </Box>
    );
};

export default AdminToolManagement;
